import React from 'react';
import { useEffect, useState } from 'react';
import {
  ThemeProviderContext,
  ThemeProviderProps,
  Theme,
} from './theme-context';

export function ThemeProvider({
  children,
  storageKey = 'vite-ui-theme',
  ...props
}: ThemeProviderProps) {
  const [theme, setTheme] = useState<Theme>(() => {
    // get from search params
    const searchParams = new URLSearchParams(window.location.search);
    const theme = searchParams.get('theme') as Theme;
    if (theme) return theme;

    const storedTheme = localStorage.getItem(storageKey) as Theme;
    if (storedTheme) return storedTheme;

    const browserTheme = window.matchMedia('(prefers-color-scheme: dark)')
      .matches
      ? 'dark'
      : 'light';

    return browserTheme;
  });

  useEffect(() => {
    const root = window.document.documentElement;

    root.classList.remove('light', 'dark');

    if (theme === 'system') {
      const systemTheme = window.matchMedia('(prefers-color-scheme: dark)')
        .matches
        ? 'dark'
        : 'light';

      root.classList.add(systemTheme);
      return;
    }

    root.classList.add(theme);
  }, [theme]);

  const value = {
    theme,
    setTheme: (theme: Theme) => {
      localStorage.setItem(storageKey, theme);
      setTheme(theme);
    },
  };

  return (
    <ThemeProviderContext.Provider {...props} value={value}>
      {children}
    </ThemeProviderContext.Provider>
  );
}
